// "When did this skill last drop?" from the fftbg.com tournaments list endpoint
// (most-recent-first, each row carries a SkillDrop). The current drop is the first
// occurrence of the token in the list; we measure the gap to the NEXT occurrence —
// i.e. how many tournaments since it last dropped before now. Anchoring to the
// first match (not index 0) keeps it correct if a newer tournament raced in on top.
//
// Returns { ago, lastMod } or null when there's no prior occurrence in the window
// (the caller then shows a "not dropped in N+" / rare message).
export function lastDropAgo(list, token) {
  if (!token || !Array.isArray(list)) return null;
  const want = String(token).toLowerCase();
  let firstIdx = -1;
  for (let i = 0; i < list.length; i++) {
    const d = list[i] && list[i].SkillDrop;
    if (d && String(d).toLowerCase() === want) {
      if (firstIdx < 0) firstIdx = i;
      else return { ago: i - firstIdx, lastMod: list[i].LastMod || null };
    }
  }
  return null;
}
